import { render } from "./ChallengeLeaderboardListItem.vue?vue&type=template&id=139c55fa&scoped=true"
import script from "./ChallengeLeaderboardListItem.vue?vue&type=script&lang=js"
export * from "./ChallengeLeaderboardListItem.vue?vue&type=script&lang=js"

import "@/css/components/challenge-leaderboard-list-item.css?vue&type=style&index=0&id=139c55fa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139c55fa"]])

export default __exports__